import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { FormControl, FormControlLabel, FormHelperText, Radio as MuiRadio } from '@material-ui/core';
import { RadioButtonUncheckedOutlined as RadioButtonUncheckedOutlinedIcon, RadioButtonCheckedOutlined as RadioButtonCheckedOutlinedIcon } from '@material-ui/icons';
import classnames from 'classnames';
export default function Radio(props) {
  var _classnames2;

  var id = props.id,
      required = props.required,
      field = props.field,
      value = props.value,
      error = props.error,
      onFieldChange = props.onFieldChange,
      classes = props.classes,
      slim = props.slim,
      disabled = props.disabled;

  var onChange = function onChange() {
    return function (event) {
      onFieldChange(id || field.name, event.target.checked);
    };
  };

  return React.createElement(FormControl, {
    required: required,
    error: !!error,
    component: 'fieldset'
  }, React.createElement(FormControlLabel, {
    label: required ? React.createElement(React.Fragment, null, field.label, "\xA0", React.createElement("span", {
      className: classes.labelAsterisk
    }, "*")) : field.label,
    classes: {
      root: classnames(_defineProperty({}, classes.slimCheckRoot, !!slim)),
      label: classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.errorColor, !!error), _defineProperty(_classnames2, classes.slimCheckLabel, !!slim), _classnames2))
    },
    control: React.createElement(MuiRadio, {
      id: id || field.name,
      className: !!error ? classes.errorColor : undefined,
      name: field.name,
      value: value,
      onChange: onChange(),
      color: 'primary',
      icon: React.createElement(RadioButtonUncheckedOutlinedIcon, {
        fontSize: slim ? 'small' : 'default'
      }),
      checkedIcon: React.createElement(RadioButtonCheckedOutlinedIcon, {
        fontSize: slim ? 'small' : 'default'
      }),
      classes: {
        root: slim ? classes.slimCheckControl : classes.baseCheckControl
      },
      disabled: disabled
    })
  }), !!error && React.createElement(FormHelperText, {
    className: classnames(_defineProperty({}, classes.slimHelperText, !!slim))
  }, error));
}